import * as ko from 'knockout';
import { MlbGame } from './models/game';
import { MlbWeek } from './models/week';

/**
 * MLB schedule builder.
 * 3 slots per week: AL (idx 0), AL vs NL (idx 1), NL (idx 2).
 * 4 post-season slots appended: Wildcard, Division Series, Championship Series, World Series.
 */
export function GetSchedule(teams: TeamDictionary, games: IGameData[]): WeekDictionary {
  const dict: WeekDictionary = {};

  const maxWeek = games.reduce((max, g) => Math.max(max, g.Week), 0);

  for (let i = 1; i <= maxWeek; i++) {
    dict[i] = [new MlbWeek('AL'), new MlbWeek('NL vs. AL'), new MlbWeek('NL')];
  }

  for (const game of games) {
    let slot: number;
    if (game.Away.Conference === game.Home.Conference) {
      slot = game.Away.Conference === 'AL' ? 0 : 2;
    } else {
      slot = 1;
    }
    (dict[game.Week][slot] as MlbWeek).games.push(
      ko.observable(
        new MlbGame(
          teams[game.Home.Conference][game.Home.Division][game.Home.TeamAbbreviation],
          teams[game.Away.Conference][game.Away.Division][game.Away.TeamAbbreviation],
          game.Week,
          game.GameScheduleNum,
          game.GameDateOffset,
          game.GameGUID,
          game.GameKey,
          (game as any).Timezone,
          (game as any).StartTimeTBD
        )
      )
    );
  }

  // Post-season slots: Wildcard, Division Series, Championship Series, World Series
  for (let offset = 1; offset <= 4; offset++) {
    dict[maxWeek + offset] = [
      new MlbWeek('NL'),
      new MlbWeek('NL vs AL'),
      new MlbWeek('AL'),
    ];
  }

  return dict;
}
